import { render, staticRenderFns } from "./modalAprobarPostulacion.vue?vue&type=template&id=60f28d88&"
import script from "./modalAprobarPostulacion.vue?vue&type=script&lang=js&"
export * from "./modalAprobarPostulacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports